/*
  If this needs to be extended in future all we need to do is add more scehma settings and add the ID's and quantities 
  into the API calls, Also consider just making one function that handles what gets added/removed from the cart before 
  running the fetch. 

  The functions to look for in this file and cart.js is checkCartItems & sendGiftToCart

*/

// Setting our variables & listeners
const freeGiftItem = window.CD_STATE.gift_product
const priceThreshold = parseInt(window.CD_STATE.gift_threshold.trim())

window["checkCart"] = async () => {
  const res = await fetch('/cart.js')
  cart = await res.json()
  const overPriceThreshold = cart.total_price / 100 >= priceThreshold
  const inCart = cart.items.find(element => element.id == freeGiftItem)

  // People will try to add the free gift product via the PDP page so we want to make sure there is always 1 (And only ever 1)
  // in the cart , if the threshold is met. 
  if (overPriceThreshold && inCart) {
    const path = "change"
    const quantity = 1
    sendGiftToCart(path, freeGiftItem, quantity)
    return
  } 

  if (!overPriceThreshold && !inCart) {
    buildMiniCartItems()
    return 
  }

  const path = overPriceThreshold ? "add" : "change"
  const quantity = overPriceThreshold ? 1 : 0
  sendGiftToCart(path, freeGiftItem, quantity)
}


const sendGiftToCart = (path, id, quantity) => {
  if (!path || !id || !quantity) {
    buildMiniCartItems()
    return
  }
    const item = {
      id: id.toString(),
      quantity: quantity
    }

  const config = { 
    headers: {
      "content-type": "application/json",
    },
    "method": "POST",
    "body": JSON.stringify(item)
  }
    
  fetch(`/cart/${path}.js`, config)
  .then((response) => {})
  .then(() => {
    buildMiniCartItems()
  })
  .catch(error => {
      console.log(error)
    })
}

function buildMiniCartItems() {
  $('.mini-cart-content #mincart-loading').show();
  $.ajax({
      method: "GET",
      url: "/cart",
      data: {
          "view": "ajax"
      },
      xhrFields: {
          withCredentials: true
      },
      dataType: 'html',
      success: function (response) {
          var listContentUpdate = ['.mini-cart-wrapper', '#cart-icon-bubble'];
          let $response = $('<div>').append($(response));
          for (let i of listContentUpdate) {
              let data = $response.find(i).first().html();
              $(i).html(data);
          }
          cartControl.rewriteListItem();
          if (typeof callback === 'function') {
              callback();
          }
      }
  });
}


// Saving these functions for later encase the client wants to make the minicart a bit more reponsive.
// function hideGiftSelector() {
//   const selectors = document.querySelectorAll('.quantity.cart')
//   console.log('running', freeGiftItem)
//   if (!selectors.length) return
//   selectors.forEach(selector => {
//     console.log('selector', selector.id)
//     if (selector.dataset.id == freeGiftItem) {
//       selector.classList.add('visually-hidden')
//     }
//   })
// }

// const runObserver = () => {
//   console.log('runObserver running')
//   const container = document.querySelectorAll('.quantity.cart')
//   const config = {
//     childList: true,
//     subtree: true
//   } 
//   const mutationFunction = (selector) => {
//     console.log('mutationFunction')
//     console.log('selector.dataset.id', selector.dataset.id)
//       if (selector.dataset.id == freeGiftItem ) {
//         selector.style.display = "none"
//         mutationObserver.disconnect()
//       }
//   }
//   const mutationObserver = new MutationObserver(mutationFunction)
//   container.forEach(selector => {
//     console.log('mutation looping')
//     mutationObserver.observe(selector, config)
//   })
// }

// runObserver()